<template>
	<div
		class="color-bar"
		@click="setColors()"
		:class="{ active: colorIndex === selectedColorIndex }"
		tabindex="0"
	>
		<div class="color-group-choice">
			<Radio
				:radioId="`radio-${colorGroup.paletteId}`"
				:radioGroupName="`${colorGroup.name}`"
				:isChecked="colorIndex === selectedColorIndex"
				:radioDescription="`${colorGroup.name} color group radio`"
			/>
			<span class="color-group-title">{{ colorGroup.name }}</span>
		</div>
		<div class="color-group-colors">
			<span
				class="color-swatch"
				:style="`background-color: ${color.hexCode}`"
				v-for="(color, index) in colorGroup.colors"
				:key="index"
			></span>
		</div>
	</div>
</template>

<script>
/* TODO: Refactor ColorBar to be a presentational/dummy component so its more resusable.
    It should rely on its parent component (BbColors) for state and actions */

import { mapState, mapActions } from 'vuex';
import Radio from '@/components/global/Radio.vue';

export default {
	name: 'ColorBar',
	components: {
		Radio,
	},
	props: {
		colorGroup: Object,
		name: String,
		colorIndex: Number,
	},
	computed: mapState({
		selectedColorIndex: (state) => state.brandBuilderEditor.selectedColorIndex,
	}),
	methods: {
		...mapActions(['selectColors', 'setColorIndex']),
		setColors() {
			this.setColorIndex(this.colorIndex);
			/* NOTE: The CampaignEditorWorkSpace handles setting the
			CSS color properties when the colorIndex changes */
		},
	},
};
</script>

<style lang="scss" scoped>
.color-bar {
	@include rem('padding', 11px 14px);
	display: flex;
	justify-content: space-between;
	align-items: center;
	border-radius: $b360-border-radius-base;
	box-shadow: inset 0 0 0 $b360-border-width-thin $border-color-light;
	background-color: $off-white;
	transition: $b360-motion-selection;
	cursor: pointer;
	user-select: none;

	&.active,
	&:hover,
	&:focus {
		box-shadow: inset 0 0 0 $b360-border-width-medium $brand-teal;

		.custom-radio {
			background-color: $brand-teal;
			box-shadow: inset 0 0 0 $b360-border-width-thin $brand-teal;
		}
	}
}

.color-group-title {
	@include rem('margin-left', 15px);
	@include typo--roboto__medium;
	color: $text-base-color;
}

.color-group-colors {
	width: 100px;
	line-height: 0;
}

.color-swatch {
	display: inline-block;
	border-radius: $b360-border-radius-base;
	@include rem('width', 30px);
	@include rem('height', 30px);

	& + & {
		@include rem('margin-left', 5px);
	}
}
</style>
